
export default function ManageInvitesRepository($http, appSettings) {

    'ngInject';
    
    return {
        getAllInvites: function () {
            return $http.get(appSettings.IcebergApiUserInfoEndpoint + '/invites/email');
        },
        getInviteByEmail: function (email) {
            return $http.get(appSettings.IcebergApiUserInfoEndpoint + '/invites/email/' + email);
        },

        getInviteByKey: function (key) {
            return $http.get(appSettings.IcebergApiUserInfoEndpoint + '/invites/key/' + key);
        },

        deleteInviteByEmail: function (email) {
            return $http.delete(appSettings.IcebergApiUserInfoEndpoint + '/invites/email/' + email);
        },

        updateInvite: function (email, data) {
            return $http.put(appSettings.IcebergApiUserInfoEndpoint + '/invites/email/' + email, data);
        }
    };
}
